{
  "birthDate": "आपकी जन्मतिथि",
  "dateFormat": "dd/mm/yyyy",
  "familyName": "आपका उपनाम",
  "helpMessage": "<p>यदि ऊपर दिया गया नंबर सही नहीं लग रहा है, या आप नहीं जानते कि क्या करना है, तो कृपया हमें <a><strong>{{phone}}</strong></a> पर कॉल करें (फिर <strong>विकल्प 2</strong> दबाएं)।</p>",
  "sendCode": "कोड भेजें",
  "text": "<p>यह बुकिंग निमंत्रण उस मरीज़ के लिए है जिसकी देखभाल इस मोबाइल नंबर वाले व्यक्ति द्वारा की जा रही है: <strong><PhonePlaceholder /></strong></p>\n<p>यदि यह आप हैं, तो कृपया नीचे <strong>मरीज़ का उपनाम</strong> और <strong>जन्मतिथि</strong> दर्ज करें और बटन पर क्लिक करें।</p>\n<p>सुरक्षा के लिए, हम आपकी पहचान सत्यापित करने हेतु आपको एक बार इस्तेमाल होने वाला <strong>4-अंकों का कोड</strong> भेजेंगे।</p>",
  "title": "<strong>{{company}} ऑनलाइन बुकिंग</strong> में आपका स्वागत है"
}
